import { Box, Paper, Typography } from "@mui/material";
import { useMemo } from "react";
import type { BilletsBetweenCobblesRow } from "../models/BilletsBetweenCobbles";

interface Props {
	rows: BilletsBetweenCobblesRow[];
}

interface BBCStats {
	count: number;
	average: number | null;
	best: number | null;
	worst: number | null;
}

const computeStats = (rows: BilletsBetweenCobblesRow[]): BBCStats => {
	if (rows.length === 0) {
		return { count: 0, average: null, best: null, worst: null };
	}
	const values = rows.map((r) => r.BBC ?? 0);
	const total = values.reduce((acc, v) => acc + v, 0);
	return {
		count: rows.length,
		average: total / rows.length,
		best: Math.max(...values),
		worst: Math.min(...values),
	};
};

const formatBBC = (v: number | null): string =>
	v == null ? "—" : v.toFixed(2);

export const BilletsBetweenCobblesSummary = ({ rows }: Props) => {
	const stats = useMemo(() => computeStats(rows), [rows]);

	return (
		<Paper elevation={1} sx={{ px: 2, py: 0.75 }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 4,
					flexWrap: "wrap",
				}}
			>
				<Typography variant="body2">
					<strong>Total Rows:</strong> {stats.count}
				</Typography>
				<Typography variant="body2">
					<strong>Average BBC:</strong> {formatBBC(stats.average)}
				</Typography>
				<Typography variant="body2">
					<strong>Best BBC:</strong> {formatBBC(stats.best)}
				</Typography>
				<Typography variant="body2">
					<strong>Worst BBC:</strong> {formatBBC(stats.worst)}
				</Typography>
			</Box>
		</Paper>
	);
};
